import React from 'react';
import { Tooltip, Icon } from 'antd';
import { capitalize } from 'lodash';

const getInviteStatus = (lastInvite) => {
  if (!lastInvite) return 'Unallocated';
  return capitalize(lastInvite?.status);
};

const InviteStatus = ({ lastInvite }) => {
  const inviteStatus = getInviteStatus(lastInvite);

  return (
    <div>
      {inviteStatus === 'Declined' ? (
        <span>
          <Tooltip title={lastInvite.rejectionNote || inviteStatus}>
            Invitation: <b>{inviteStatus}</b> <Icon type="info-circle" />
          </Tooltip>
          <i className="fa-thin fa-circle-info" />
        </span>
      ) : (
        <span>
          {'Invitation: '}
          <b>{inviteStatus}</b>
        </span>
      )}
    </div>
  );
};

export default InviteStatus;
